import { Menu, X } from "lucide-react";

export function Topbar({
  menuOpen,
  onMenuToggle,
}: {
  menuOpen: boolean;
  onMenuToggle: () => void;
}) {
  return (
    <header className="absolute inset-x-0 top-0 z-20 flex h-14 items-center bg-background px-3 text-foreground md:h-4 md:px-6">
      <button
        type="button"
        onClick={onMenuToggle}
        aria-label={menuOpen ? "Close menu" : "Open menu"}
        aria-expanded={menuOpen}
        className="flex h-11 w-11 items-center justify-center rounded-md hover:bg-base md:hidden"
      >
        {menuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
      </button>
    </header>
  );
}
